import { Component, OnInit, Input, ViewContainerRef } from '@angular/core';
import { trigger, transition, useAnimation } from '@angular/animations';
import { fadeInDown } from 'ng-animate';
import { FormBuilder, NgForm, FormGroup, Validators, FormControl, AbstractControl } from '@angular/forms';
import { ActivatedRoute, Router } from "@angular/router";
import { ApirequestService } from '../../../../../services/apirequest/apirequest.service';
import { ApiurlsService } from '../../../../../services/api-urls/apiurls.service';
import { UtilityService } from '../../../../../services/utilities/utilities.services';
import { BlurInputErrorMatcher } from '../../../../../modules/material/material.errror';
import { CommonService } from '../../../../../services/apiservices/common.service';




@Component({
  selector: 'hybse-admin-adduser',
  templateUrl: './adduser.component.html',
  styleUrls: ['./adduser.component.css'],
  animations: [
    trigger('fadeInDown', [transition('* => *', useAnimation(fadeInDown, {
      params: {
        timing: 1,
        a: '-10px'
      }
    }))])
  ],
})
export class AdduserComponent implements OnInit {

  constructor(private _fb: FormBuilder,
    private _req: ApirequestService,
    private _urls: ApiurlsService,
    private _utils: UtilityService,
    private route: ActivatedRoute,
    private router: Router,
    private commonService: CommonService,
    private vcr: ViewContainerRef) {
  }
  fadeInDown: any;
  createUserForm: FormGroup;
  @Input() actionType: string = 'add';
  @Input() userType: string = 'Admin';
  blurMatcher = new BlurInputErrorMatcher();


  formTitle: string = 'Add New User';
  formResponseMsg: string = '';
  alertStatusMessage: boolean;
  showLoader: boolean = false;
  formSubmitted: boolean = false;
  userId: any;
  userName: string = '';
  url: string = '';

  getActionType() {
    if (this.actionType == 'edit') {
      this.formTitle = 'Edit User';
      this.showLoader = true;
    }
  }

  getuserType() {
    setTimeout(() => {
      if (this.userType == 'Investor') {
        this.createUserForm.controls['userrole'].setValue('Admin');
      }
    }, 500);
  }




  getUserData() {
    let data = { data: { idUser: this.userId } };
    this._req.fetchApiData(this._urls.getUserDataUrl, data).subscribe(
      (data: any) => {
        this.setUserData(data.data);
      }
    )
  }
  userDetail: any = '';
  setUserData(data) {
    if (data != "" || typeof data != "undefined") {
      this.userName = data.username;
      this.userDetail = data;
      this.createUserForm.controls['upass'].setValue('');
      this.createUserForm.controls['confirmpass'].setValue('');
      if (this.userType == 'Admin') this.createUserForm.controls['userrole'].setValue(data.userType);
      this.createUserForm.controls['useremail'].setValue(data.email);
      this.createUserForm.controls['firstname'].setValue(data.firstName);
      this.createUserForm.controls['lastname'].setValue(data.lastName);
      this.createUserForm.controls['usergender'].setValue(data.gender);
      this.createUserForm.controls['userenabled'].setValue(data.isActive ? '1' : '0');
      this.showLoader = false;
    }
  }

  createUserFormInit() {
    this.createUserForm = this._fb.group({
      //'uname': ['', [Validators.required]],
      'upass': ['', this.actionType == 'add' ? [Validators.required] : []],
      'confirmpass': ['', [this.confirmPasswordCheck.bind(this, 0)]],
      'userrole': ['', (this.userType == 'Investor' || this.userType == 'Issuer') ? [] : [Validators.required]],
      'useremail': ['', [Validators.required, this.validateEmail]],
      'firstname': ['', []],
      'lastname': ['', []],
      'usergender': ['Male', [Validators.required]],
      'userenabled': ['1', [Validators.required]],
      'register': ['LS', [Validators.required]]
    },
      { updateOn: 'submit', validator: this.checkConfirmPassword }
    );

  }

  validateEmail(input: FormControl) {
    let val = input.value;
    let regex = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
    if (!regex.test(val) && val != '') {
      return {
        emailInvalid: true
      }
    }
    return null;
  }

  confirmPasswordCheck(i: any, input: any) {
    if (typeof this.createUserForm != 'undefined') {
      let password = this.createUserForm.controls['upass'].value;
      let confirmPass = this.createUserForm.controls['confirmpass'].value;
      if ((password != confirmPass) && (confirmPass != '')) {
        return { pwInvalid: true };
      } else {
        return null;
      }
    }
    return null;
  }

  checkConfirmPassword(control: AbstractControl) {
    let password = control.get('upass').value;
    let confirmPassword = control.get('confirmpass').value;
    if ((password != confirmPassword) && password != '') {
      return {
        passwordInvalid: true
      }
    }
    return null;
  }

  createUpdateUser() {
    let formVal = this.createUserForm.value;
    this.formSubmitted = true;
    let seed = this;
    if (this.createUserForm.valid) {
      this.showLoader = true;
      let data: any = {
        data: {
          firstName: formVal.firstname,
          lastName: formVal.lastname,
          email: formVal.useremail,
          password: formVal.upass,
          avatar: '',
          gender: formVal.usergender,
          isActive: formVal.userenabled,
          register: formVal.register
        }
      };
      let url = '';
      if (this.userType == 'Admin') {
        url = this._urls.createUserAdminUrl;
      }
      else if (this.userType == 'Investor') {
        url = this._urls.createUserInvestorUrl;
      }
      else {
        url = this._urls.createUserIssuerUrl;
      }

      (this.userType == 'Admin') ? data.data.userType = formVal.userrole : data.data.userType = this.userType;
      if (this.actionType == 'edit') {
        //data.idUser = this.userId;
        data.data.idUser = this.userId;
        //url = this._urls.updateUserUrl;
        url = (this.userType == 'Admin') ? this._urls.updateAdminUrl : this._urls.updateUserUrl;
      }
      this._req.fetchApiData(url, data).subscribe(
        (data: any) => {
          let response = data.data;
          let responseErr = data.error;
          this.showLoader = false;
          this.formSubmitted = false;
          this._utils.scrollToY(0, 400, 'easeInOutQuint');
          if (response != '') {
            if (this.actionType === 'edit')
              this.commonService.showSuccessMessage(this.commonService.dataUpdation);
            else
              this.commonService.showSuccessMessage(this.commonService.dataCreation)
            this.formResponseMsg = (this.actionType == 'edit') ? 'User has been updated Successfully' : 'User has been created Successfully';
            this.alertStatusMessage = true;
            setTimeout(() => {
              this.routeToPage();
            }, 2000);
          } else {
            this.commonService.showInformationMessage(this.commonService.noRecordMsg);
          }
          if (responseErr != '') {
            this.formResponseMsg = responseErr['Error Msg'];
            this.alertStatusMessage = false;
          }
        },
        error => {

        },
        () => {
        }
      );

    }
  }

  cancelUserCreate() {
    this.routeToPage();
  }
  routeToPage() {
    if (this.userType == 'Admin') {
      this.router.navigate(['/admin/user-lists'])
    }
    else if (this.userType == 'Investor') {
      this.router.navigate(['/investor/user-lists'])
    }
    else {
      this.router.navigate(['/issuer/user-lists'])
    }
  }



  ngOnInit() {
    this.createUserFormInit();

    this.route.params.subscribe(
      params => {
        this.userId = params.id;
        if (typeof this.userId != 'undefined') this.getUserData();
      }
    )
  }

  ngOnChanges() {
    this.getActionType();
    this.getuserType();
  }
}



// WEBPACK FOOTER //
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/app/components/pages/users/admin/adduser/adduser.component.ts